document.addEventListener("DOMContentLoaded", function () {
  // フッターのリンクブロックのアコーディオン
  const footerLinkTitles = document.querySelectorAll(".c-footer__links-title");

  footerLinkTitles.forEach((title) => {
    title.addEventListener("click", function () {
      const ul = this.nextElementSibling;
      this.classList.toggle("is-active");
      ul.classList.toggle("is-active");
    });
  });
});
